import { MaybeNull } from '@/shared/types';
import { Preferences } from '@capacitor/preferences';
import { CapacitorHttp } from '@capacitor/core';

export const getRemoteETag = async (url: string): Promise<MaybeNull<string>> => {
  const headResp = await CapacitorHttp.request({
    method: 'HEAD',
    url,
  });

  return headResp.headers['etag'] || headResp.headers['ETag'] || null;
};

export const saveETag = async (fileName: string, etag: string) => {
  await Preferences.set({
    key: `etag:${fileName}`,
    value: etag,
  });
};

export const getLocalETag = async (fileName: string) => {
  const { value } = await Preferences.get({
    key: `etag:${fileName}`,
  });

  return value;
};
